import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  ActivitySectionDirective,
  CallWaiterService,
  InvoiceQrcodeImageService,
  isDefined,
  isNotNull,
  RestaurantTableService,
  UserActivityClickTrackingDirective,
} from '@core';
import { filter, map } from 'rxjs/operators';
import { shareReplay } from 'rxjs';
import { transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn } from 'ng-animate';

@Component({
  selector: 'app-invoice-tab',
  templateUrl: './invoice-tab.component.html',
  styleUrls: ['./invoice-tab.component.scss'],
  imports: [
    TranslateModule,
    UserActivityClickTrackingDirective,
    ActivitySectionDirective,
  ],
  animations: [
    trigger('fadeIn', [
      transition(':enter', useAnimation(fadeIn, {
        params: { timing: 0.4 },
      })),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceTabComponent {

  public readonly currentLanguage = toSignal(this.translate.onLangChange.pipe(
    map((event) => event.lang),
    shareReplay(1),
  ), { initialValue: this.translate.currentLang ?? this.translate.defaultLang });

  public readonly table = toSignal(this.restaurantTable.table$);

  public readonly qrUrl = toSignal(this.invoiceQrcodeImage.file$);

  public readonly withCallWaiterRequestBill = toSignal(this.callWaiter.withRequestBill$, {
    initialValue: false,
  });

  public readonly callWaiterMain = toSignal(this.callWaiter.mainStatus$, {
    requireSync: true,
  });

  public readonly callWaiterRequestBill = toSignal(this.callWaiter.requestBillStatus$, {
    requireSync: true,
  });

  public readonly callWaiterAnotherRound = toSignal(this.callWaiter.anotherRoundStatus$, {
    requireSync: true,
  });

  public readonly showDisclaimer = toSignal(this.restaurantTable.table$.pipe(
    map((table) => {
      return table?.integrations.find((integration) => {
        return integration.provider === 'bostonPizzaUI';
      })?.credentials.notAcceptingRewardsCardsDisclaimer;
    }),
    filter((show) => isDefined(show) && isNotNull(show)),
  ), { initialValue: false });

  constructor(
    private readonly translate: TranslateService,
    private readonly restaurantTable: RestaurantTableService,
    private readonly invoiceQrcodeImage: InvoiceQrcodeImageService,
    private readonly callWaiter: CallWaiterService,
  ) {}

  public handlerCallWaiterToPay($event: MouseEvent): void {
    if ($event.target instanceof HTMLElement) {
      $event.preventDefault();
      this.callWaiter.setRequestBill(!this.callWaiterRequestBill());
    }
  }

}
